<pre
  #messageContainer
  class="messages"
  (click)="onShowConsolePanel()"
>{{ lastThreeLogLines$ | async }}</pre>
